<template>
  <div class="content">
    <el-form ref="schemeForm" :model="schemeForm" :rules="schemeRules"  label-width="100px">
      <el-card class="box-card">
        <div style="margin-left:30px">
          <div style="font-size: 14px;text-align: left;">为代理商某一批次的卡分配指定套餐，设置底价，下级代理商将按此批次卡的底价设置自己的底价和售价</div>
          <div style="font-size: 14px;text-align: left;">1、先选择代理商，再批量选择套餐；</div>
          <div style="font-size: 14px;text-align: left;"> 2、批量设置套餐的底价和售价；</div>
          <div style="font-size: 14px;text-align: left;"> 3、输入批量卡号或者号段；</div>
          <div style="font-size: 14px;text-align: left;"> 4、查询卡片按钮是用于校验输入的卡号或者号段是否正确；</div>
          <div style="font-size: 14px;text-align: left;"> 5、查询卡片查找的是当前页面选择的代理商非所有卡；</div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>方案信息</span>
        </div>
        <el-form-item label="方案名称" prop="name" style="width:60%">
            <el-input v-model="schemeForm.name" placeholder="方案名称"></el-input>
        </el-form-item>
        
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="color: #ff4949;margin-right: 4px;">*</span><span>套餐信息</span>
        </div>
        <el-table :data="schemeForm.services" row-key="id"
          :default-expand-all="true" max-height="400" border
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column type="index" align="center" width="60px"></el-table-column>
          <el-table-column prop="productName" label="套餐名称" align="center"  :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="showProductName" label="公众号展示名称" align="center" width="200">
            <template #default={row}>
              <el-input v-if="!!row.productName" v-model="row.showProductName"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="operationName" label="运营商" align="center"  ></el-table-column>
          <el-table-column prop="basePrice" label="成本价（元）" align="center"  ></el-table-column>
          <el-table-column prop="ledgerPrice" label="底价（元）" align="center" >
            <template #default={row}>
              <el-input style="width: 80px;" v-model="row.ledgerPrice"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="salePrice" label="售价（元）" align="center" >
            <template #default={row}>
              <el-input style="width: 80px;" v-model="row.salePrice"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix box-title">
            <div class="title">
                <span>添加卡片</span>
            </div>
            <div class="checked">
                <!-- <el-checkbox v-model="schemeForm.checkCard">
                    <span style="color:#1890ff">全部选中</span>
                </el-checkbox> -->
            </div>
        </div>
        <el-form-item label="代理商" prop="userId" style="width:60%">
            <el-select v-model="schemeForm.userId" placeholder="请选择代理商" clearable filterable  style="width:100%">
              <el-option v-for="item in agentList" :key="item.userId" :label="'['+`${item.username}`+']' + `${item.company}`" :value="item.userId"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item v-if="!schemeForm.checkCard" label="ICCID列表" prop="iccids" >
          <el-input
            v-model="schemeForm.iccids"
            type="textarea"
            :placeholder="'以回车键分割ICCID\n'"
            rows="6"
            style="width:420px;font-size:14px"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="!schemeForm.checkCard" label="ICCID范围" prop="startIccid" >
            <el-input
            v-model="schemeForm.startIccid"
            style="width: 200px;margin-right: 10px;"
            placeholder="包含开始值"
            ></el-input>
            <span>-</span>
            <el-input
            v-model="schemeForm.endIccid"
            style="width: 200px;margin-left: 10px;"
            placeholder="包含终止值"
            ></el-input>
        </el-form-item>
        <el-form-item label="">
            <el-button type="primary" size="medium" @click="handleSeleectCard">查询卡片</el-button>
        </el-form-item>

        <el-table :data="tableData" v-loading="tableLoading">
            <el-table-column type="index" label="编号" align="center" width="100"></el-table-column>
            <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
            <el-table-column prop="msisdn" label="MSISDN" align="center"></el-table-column>
        </el-table>
        <div class="block" style="margin-top: 30px;">
            <pagination v-show="tableTotal>0" :total="tableTotal" :page-sizes="[10, 20, 30, 40]" :page-size="tablePageSize" :page.sync="tablePage"
            :limit.sync="tablePageSize" @pagination="initUnAllotTableData" />
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix box-title">
            <span>已分配卡片</span>
        </div>
        <el-table :data="allotTableData" v-loading="allotLoading">
            <el-table-column type="index" label="编号" align="center" width="100"></el-table-column>
            <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
            <el-table-column prop="msisdn" label="MSISDN" align="center"></el-table-column>
        </el-table>
        <div class="block" style="margin-top: 30px;">
            <pagination v-show="allotTableTotal>0" :total="allotTableTotal" :page-sizes="[10, 20, 30, 40]" :page-size="allotTablePageSize" :page.sync="allotTablePage"
            :limit.sync="allotTablePageSize" @pagination="initAllotTableData" />
        </div>
      </el-card>
    </el-form>
    <div class="foot">
		<el-button type="primary" @click="submitScheme">保存方案</el-button>
	</div>
  </div>
</template>
<script>
import { agentListsData , baseSchemeProductSubList , baseSchemeCard} from "@/api/api.js"; 
import { subSaveBaseScheme } from "@/api/api.js";
export default {
  name:'schemeAdd',
  data() {
    return {
      schemeId:undefined,
      schemeForm:{
        productName:undefined,
        userId:undefined,
        iccids:undefined,
        startIccid:undefined,
        endIccid:undefined,
        checkCard:false,
        services:[]
      },
      schemeRules:{
        name: [
          { required: true, message: "请输入方案名称", trigger: "blur" },
        ],
      },
      agentList:[],
      tableLoading:false,
      tableData:[],
      tableTotal:0,
      tablePage:1,
      tablePageSize:10,

      allotLoading:false,
      allotTableData:[],
      allotTableTotal:0,
      allotTablePage:1,
      allotTablePageSize:10,

    };
  },
  methods: {
    initAgentList(){
      let params = {
        page: 1,
        pageSize: 5000,
      };
      agentListsData(params).then(res => {
        this.agentList = res.data.data.records;
      });
    },
    handleSeleectCard(){
      if(!this.schemeForm.userId){
        this.$modal.msgError("请选择代理商");
        return 
      }
      this.initUnAllotTableData()
    },
    initUnAllotTableData(){
      this.tableLoading = true;
      let params = {
        model:{
          status:"0",
          userId:this.schemeForm.userId,
		      schemeId:this.schemeId,
          iccid: this.schemeForm.iccids && this.schemeForm.iccids.replace(/\n/g, ' '),
          startIccid:this.schemeForm.startIccid,
          endIccid:this.schemeForm.endIccid
		    },
        page: this.tablePage,
        pageSize: this.tablePageSize,
      };
      baseSchemeCard(params).then(res => {
          this.tableData = res.data.data.records;
          this.tableTotal = res.data.data.total;
          this.tableLoading = false;
      });
    },
    initAllotTableData(){
      this.allotLoading = true;
      let params = {
        model:{
		  schemeId:this.schemeId,
          status:"1"
		},
        page: this.tablePage,
        pageSize: this.tablePageSize,
      };
      baseSchemeCard(params).then(res => {
          this.allotTableData = res.data.data.records;
          this.allotTableTotal = res.data.data.total;
          this.allotLoading = false;
      });
    },
    initSubSchemeProduct(){
        baseSchemeProductSubList({id:this.schemeId}).then(res=>{
            this.schemeForm.services = res.data.data
        })
    },
    submitScheme(){
      this.$refs.schemeForm.validate(valid=>{
        if (valid) {
          let data = this.getProdcutData()
          if(data.length == 0){
            this.$modal.msgError("请选择套餐");
            return 
          }
          let arrShow = true;
          let msg = "底价或者售价输入不正确";
          data.forEach(item=>{
            if(!item.ledgerPrice){
              arrShow = false
              msg="底价不能为空";
              return 
            }
            if(item.ledgerPrice < item.basePrice){
              arrShow = false
              msg="底价必须大于成本价";
              return 
            }
            if(!item.salePrice){
              arrShow = false
              msg="售价不能为空";
              return 
            }
            if(item.salePrice < item.ledgerPrice){
              arrShow = false
              msg="售价必须大于底价";
              return 
            }
          })
          if(!arrShow){
            this.$modal.msgError(msg);
            return 
          }else{
            //保存方案
            let params = {
              ...this.schemeForm,
              schemeId:this.schemeId,
              iccids: !!this.schemeForm.iccids ? this.schemeForm.iccids.split("\n") : []
            };
            subSaveBaseScheme(params).then(res=>{
              this.$message({type: 'success',message: '新建方案成功'});
              this.$router.push('/scheme/list')
            })
          }
        }
      })
    },
    getProdcutData(){
      let data = this.schemeForm.services;
      if(!!data && data.length>0){
        let prodcuts = []
        data.forEach(item=>{
          prodcuts.push(item)
          let children = item.children;
          if(children && children.length>0){
              children.forEach(ch=>{
                prodcuts.push(ch);
              })
          }
        })
        return prodcuts;
      }
      return [];  
    },
    formatFlow(flow){
      if(!flow){
        return null;
      }
      if(0 > flow){
        flow = "畅享";
      }else if(1024 > flow > 0){
        flow = flow + 'M';
      }else if(flow >= 1024){
        flow = (flow/1024).toFixed(2) + 'G';
      }
      return flow;
    },
  },
  mounted() {
  },
  created() {
    this.schemeId = this.$route.params && this.$route.params.id
    this.initAgentList()
    this.initSubSchemeProduct()
    this.initAllotTableData()
  }
};
</script>
<style scoped lang="less">
  .box-card {
    margin-bottom: 26px;
    .box-title{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-items: center;
        .checked{
            margin-left: 20px;
        }
    }
  }
  .foot {
		width: calc(100% - 210px);
		position: fixed;
		right: 0;
		bottom: 0;
		height: 60px;
		line-height: 60px;
		background-color: white;
		text-align: center;
		padding: 0 20px;
    z-index: 99999;
	}
</style>
